import { useMemo } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { selectMap3dWorkspace } from 'src/map-3d/shared/map-3d-slices';
import { LayerType } from 'src/shared/api';
import { CrossSectionNoPointCloud } from './components';
import { CrossSectionForm } from './cross-section-form';
import { type CrossSectionSidecardProps } from './types';

export const CrossSectionSidecard: React.FC<CrossSectionSidecardProps> = ({
  onGenerateCrossSection,
  onOpenGraphViewer,
  isGenerating,
  isGraphVisible,
}) => {
  // Selectors.
  const { workspaceLayers } = useAppSelector(selectMap3dWorkspace);

  // Memoized Values.
  const hasVisiblePointCloudLayers = useMemo(
    () =>
      Object.values(workspaceLayers).some(
        (layer) => layer.show && layer.type === LayerType.PointCloud,
      ),
    [workspaceLayers],
  );

  // Renders.
  if (!hasVisiblePointCloudLayers) {
    return <CrossSectionNoPointCloud />;
  }

  return (
    <div className="cross-section">
      <CrossSectionForm
        onGenerateCrossSection={onGenerateCrossSection}
        onOpenGraphViewer={onOpenGraphViewer}
        isGenerating={isGenerating}
        isGraphVisible={isGraphVisible}
      />
    </div>
  );
};
